<template>
  <div class="app">
    <Card v-if="!openExcel" dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="80" label-position="left" inline>
          <FormItem label="项目名称:">
            <Input v-model="query.Name" placeholder="请输入项目名称"></Input>
          </FormItem>
          <FormItem label="采购负责人:" :label-width="100">
            <Input v-model="query.CGB_Header" placeholder="请输入采购负责人"></Input>
          </FormItem>
          <FormItem label="导入人:">
            <Input v-model="query.ImportUserName" placeholder="请输入导入人"></Input>
          </FormItem>
          <FormItem label="状态:">
            <Select placeholder="请选择状态" v-model="query.Status" style="width: 180px">
              <Option value="">------</Option>
              <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="导入时间:">
            <DatePicker v-model="rangeTime" type="daterange" format="yyyy-MM-dd" style="width: 100%" placement="bottom-end" placeholder="请选择发生时间"></DatePicker>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile" :headers="header" accept=".xlsx,.xls,.excel" :show-upload-list="false" :action="action" :data="BOMdata">
              <Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入BOM表</Button>
            </Upload>
            <Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile" :headers="header" accept=".xlsx,.xls,.excel" :show-upload-list="false" :action="action" :data="JDdata">
              <Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入金蝶数据</Button>
            </Upload>
          </FormItem>
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <div v-else>
      <Excel @closeExcel="closeExcel" :id="id" :status="openStatus" :cid="cid" :bomStatus="bomStatus" />
    </div>
    <Modal v-model="isShowDelete" :mask-closable="false" class="modal-cont">
      <p class="content">确认删除该管制表吗？</p>
      <div slot="footer" class="footer">
        <Button @click="isShowDelete = false">取消</Button>
        <Button type="primary" @click="deleteFile">确认</Button>
      </div>
    </Modal>
    <Modal v-model="isShowFeedback" title="设置反馈规则" :mask-closable="false" class="">
      <Form ref="feedbackForm" :model="feedbackFormData" label-width="100" :rules="feedbackRules">
        <FormItem label="反馈规则：" :label-width="100" prop="feedbackType">
          <RadioGroup v-model="feedbackFormData.feedbackType">
            <Radio v-for="item in feedbackTypeData" :key="item.value" :label="item.value">{{ item.text }}</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer" class="footer">
        <Button @click="isShowFeedback = false">取消</Button>
        <Button type="primary" :loading="feedbackLoading" @click="confirmFeedback">确认</Button>
      </div>
    </Modal>
    <OperationLog v-model="isShowOperation" :id="id" @close-modal="closeDetail" @open-excel="closeDetailOpenExcel" v-if="isGetData" />
    <Spin class="spin" fix v-if="spinShow" size="large">导入中...</Spin>
  </div>
</template>

<script>
import moment from 'moment'
import Excel from './excel.vue'
import OperationLog from './operationlLog.vue'
import Util from '../../../lib/util'

export default {
  name: 'bomupload',
  data() {
    return {
      query: {
        Name: '',
        ImportUserName: '',
        CGB_Header: '',
        Status: '',
        ImportStartTime: '',
        ImportEndTime: '',
        MaxResultCount: 10,
        SkipCount: 0,
        IncludeCreatoUser: true,
      },
      list: [],
      rangeTime: [],
      columns: [],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      loading: false,
      openExcel: false,
      initData: [],
      spinShow: false,
      action: this.$constDefinition.baseUrl + '/CGBFile/UploadByCGB_BOM',
      BOMdata: {
        // 例如
        importDataType: 1,
      },
      JDdata: {
        importDataType: 5,
      },
      header: {
        Authorization: `Bearer ${Util.abp.auth.getToken()}`,
      },
      openStatus: null,
      isSupervisor: false,
      statusList: [],
      isShowOperation: false,
      isGetData: false,
      cid: null,
      isShowConfirm: false,
      isShowBack: false,
      isShowDelete: false,
      reason: '',
      bomStatus: 0,
      feedbackTypeData: [],
      isShowFeedback: false,
      feedbackLoading: false,
      feedbackFormData: {
        id: 0,
        feedbackType: null,
      },
      feedbackRules: {
        feedbackType: [
          { required: true, type: 'number', message: '请选择反馈规则', trigger: 'change' },
        ],
      },
    }
  },
  components: {
    Excel,
    OperationLog,
  },
  mounted() {
    this.getInit()
    this.getpage()
    this.getColumns()
  },
  methods: {
    getInit() {
      this.$Ajax.get('/api/services/app/BOMImportRecord/GetMgrInitData').then((res) => {
        this.isSupervisor = res.data.result.is采购部主管
        this.statusList = res.data.result.statusData
        this.feedbackTypeData = res.data.result.feedbackTypeData
      })
    },
    async getpage(params) {
      // console.log(this.rangeTime)
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }

      if (this.rangeTime[0]) {
        // console.log(moment(this.rangeTime[0]).format("YYYY-MM-DD"))
        this.query.ImportStartTime = moment(this.rangeTime[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTime[1]) {
        this.query.ImportEndTime = moment(this.rangeTime[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTime[0]) {
        this.query.ImportStartTime = ''
      }
      if (!this.rangeTime[1]) {
        this.query.ImportEndTime = ''
      }
      this.loading = true
      const data = await this.$Ajax.get('/api/services/app/BOMImportRecord/QueryDto', {
        params: this.query,
      })
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.loading = false
    },
    getColumns() {
      this.columns = [
        {
          title: '导入数据类型',
          key: 'importDataTypeText',
          minWidth: 80,
        },
        {
          title: '项目名称',
          key: 'name',
          minWidth: 80,
        },
        {
          title: '全名',
          key: 'fullName',
          minWidth: 50,
        },
        {
          title: '导入时间',
          key: 'creationTimeText',
          minWidth: 110,
        },
        {
          title: '导入人',
          minWidth: 50,
          render: (h, params) => {
            return h('span', params.row.creatorUser.name)
          },
        },
        {
          title: '采购负责人',
          minWidth: 50,
          key: 'cgB_Headers',
        },

        {
          title: '状态',
          key: 'statusText',
          minWidth: 50,
        },
        {
          title: '操作',
          minWidth: 330,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'success',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.isShow_下载源文件按钮 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      this.downloadFile(params.row.id, params.row.fileName)
                    },
                  },
                },
                '下载源文件'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.isShow_生成管制表按钮 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      this.generateFile(params.row.id, params.row.status)
                    },
                  },
                },
                '生成管制表'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.isShow_编辑管制表按钮 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      this.updateFile(params.row.id, params.row.status)
                    },
                  },
                },
                '编辑管制表'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    //主管一直删除
                    display: params.row.isShow_删除按钮 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      this.id = params.row.id
                      this.isShowDelete = true
                    },
                  },
                },
                '删除'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.isShow_设置反馈类型按钮 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      this.openFeedbackModal(params.row)
                    },
                  },
                },
                '设置规则'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.openDetail(params.row.id)
                    },
                  },
                },
                '操作日志'
              ),
            ])
          },
        },
      ]
    },
    reset() {
      this.query.Name = ''
      this.query.ImportUserName = ''
      this.query.CGB_Header = ''
      this.query.Status = ''
      this.query.ImportStartTime = ''
      this.query.ImportEndTime = ''
      this.rangeTime = ''
      ;(this.pageSize = 10), (this.currentPage = 1), (this.totalCount = 0), this.getpage(1)
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
    beforeImportFile() {
      this.spinShow = true
    },
    //导入
    importFile(e) {
      console.log('🚀 ~ file: BomUpload.vue:324 ~ importFile ~ e:', e)
      // this.$Message.success({
      //     content: e.result.message,
      //     duration: 26,
      // });
      this.$Message.success({
        render: (h) => {
          return h(
            'span',
            {
              style: {
                marginRight: '5px',
                // background: '#19be6b',
              },
            },
            e.result.message
          )
        },
        duration: 26,
        background: true,
      })
      this.getpage()
      this.spinShow = false
    },
    errorImportFile(error, file, fileList) {
      // console.log(error, file, fileList)
      this.$Message.error({
        content: file.error.message,
        duration: 3,
      })
      this.getpage()
      this.spinShow = false
    },
    //生成
    generateFile(id, status) {
      this.id = id
      this.openStatus = 1
      this.bomStatus = status
      this.openExcel = true
    },
    //下载
    downloadFile(id, fileName) {
      let _this = this
      let consturl = `${this.$constDefinition.baseUrl}/cgbfile/downloadBOMSourceFile/id?id=${id}` //下载地址url
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        console.log(xhr)
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = fileName // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    //编辑
    updateFile(id, status) {
      this.id = id
      this.openStatus = 2
      this.bomStatus = status
      this.openExcel = true
    },
    //审核
    // check(id){
    //     this.id = id
    //     this.isShowConfirm = true
    // },
    //删除
    async deleteFile() {
      const data = await this.$Ajax.delete(`/api/services/app/BOMImportRecord/Delete?Id=${this.id}`)
      console
      if (data.success === false) {
        this.$Message.error({
          content: data.error.message,
        })
        return
      }
      this.$Message.success({
        content: '删除成功',
      })
      this.isShowDelete = false
      this.getpage()
    },
    //操作日志
    openDetail(id) {
      this.id = id
      this.isShowOperation = true
      this.isGetData = true
    },
    //操作日志关闭
    closeDetail() {
      this.isShowOperation = false
      this.isGetData = false
    },
    //操作日志打开excel查看对比
    closeDetailOpenExcel(id, cid) {
      this.closeDetail()
      this.id = id
      this.cid = cid
      this.openStatus = 3
      this.openExcel = true
    },
    closeExcel(val) {
      this.id = 0
      this.openExcel = false
      if (val) {
        this.getpage()
      }
    },
    closeSpin() {
      this.spinShow = false
    },
    // 打开设置反馈规则弹窗
    openFeedbackModal(row) {
      this.feedbackFormData.id = row.id
      // 如果已有选中的类型，设置默认值
      const selectedItem = this.feedbackTypeData.find((item) => item.selected)
      this.feedbackFormData.feedbackType = selectedItem ? selectedItem.value : null
      this.isShowFeedback = true
    },
    // 确认设置反馈规则
    confirmFeedback() {
      this.$refs.feedbackForm.validate(async (valid) => {
        if (valid) {
          this.feedbackLoading = true
          try {
            const data = await this.$Ajax.post(
              '/api/services/app/BOMImportRecord/SetFeedbackType',
              {
                id: this.feedbackFormData.id,
                feedbackType: this.feedbackFormData.feedbackType,
              }
            )
            if (data.success === false) {
              this.$Message.error({
                content: data.error.message,
              })
              return
            }
            this.$Message.success({
              content: '设置成功',
            })
            this.isShowFeedback = false
            this.getpage()
          } catch (error) {
            this.$Message.error({
              content: error.message || '设置失败',
            })
          } finally {
            this.feedbackLoading = false
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.ivu-upload {
  display: inline-block;
}

.ivu-btn {
  margin-left: 5px;
}
.spin {
  font-size: 20px;
}

.content {
  text-align: center;
  font-size: 16px;
}

.footer {
  text-align: center;
}

.modal-cont /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal {
  top: 300px;
}
</style>
